import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type PerformerToolbarProps = {
  canManage?: boolean;
  onCreate: () => void;
};

export function PerformerToolbar({
  canManage,
  onCreate,
}: PerformerToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="flex items-center font-bold text-2xl tracking-tight">
          ນັກສະແດງ
        </h2>
        <p className="text-muted-foreground">ຈັດການຂໍ້ມູນນັກສະແດງໃນລະບົບ.</p>
      </div>
      {canManage && (
        <div className="flex items-center space-x-2">
          <Button onClick={onCreate}>
            <PlusIcon className="h-4 w-4" />
            ເພີ່ມນັກສະແດງ
          </Button>
        </div>
      )}
    </div>
  );
}
